<template>
  <v-container fluid class="auth-bg fill-height">
    <v-row align="center" justify="center" class="fill-height">
      <v-col cols="12" sm="10" md="8" lg="6">
        <v-card class="auth-card pa-8">
          <div class="auth-section-header">
            <v-icon small color="primary" class="mr-2">mdi-account-check</v-icon>
            <span class="auth-section-title">Cadastro · Etapa final</span>
          </div>

          <div class="d-flex align-center justify-space-between mt-2">
            <div>
              <div class="auth-title">Complete seu cadastro</div>
              <div class="auth-subtitle mt-1">
                Escolha o tipo da sua conta (apenas uma vez).
              </div>
            </div>
            <v-avatar size="48" class="role-header-avatar">
              <v-icon color="primary">mdi-account-check</v-icon>
            </v-avatar>
          </div>

          <v-divider class="my-6" />

          <v-row>
            <v-col cols="12" md="6">
              <v-card
                class="role-card"
                :class="{ selected: roleId === 1 }"
                outlined
                @click="roleId = 1"
              >
                <v-card-text class="d-flex align-start py-5">
                  <v-avatar size="48" class="mr-4 role-avatar role-avatar--doctor">
                    <v-icon color="primary">mdi-stethoscope</v-icon>
                  </v-avatar>
                  <div class="flex-grow-1">
                    <div class="role-title">Profissional de Saúde</div>
                    <div class="role-description mt-1">
                      Acesso como médico para gerenciar pacientes e agenda.
                    </div>
                  </div>

                  <v-icon v-if="roleId === 1" color="primary" class="ml-2">
                    mdi-check-circle
                  </v-icon>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="6">
              <v-card
                class="role-card role-card--success"
                :class="{ selected: roleId === 3 }"
                outlined
                @click="roleId = 3"
              >
                <v-card-text class="d-flex align-start py-5">
                  <v-avatar size="48" class="mr-4 role-avatar role-avatar--assistant">
                    <v-icon color="#43a047">mdi-account-multiple</v-icon>
                  </v-avatar>
                  <div class="flex-grow-1">
                    <div class="role-title">Assistente</div>
                    <div class="role-description mt-1">
                      Acesso para apoiar a clínica e organizar atendimentos.
                    </div>
                  </div>

                  <v-icon v-if="roleId === 3" color="#43a047" class="ml-2">
                    mdi-check-circle
                  </v-icon>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-alert
            v-if="error"
            type="error"
            outlined
            border="left"
            class="auth-alert mt-4"
          >
            {{ error }}
          </v-alert>

          <div class="d-flex align-center justify-space-between mt-6">
            <div class="auth-hint flex-grow-1 mr-4">
              Você pode alterar informações do perfil depois, mas o tipo de
              conta é definido uma única vez.
            </div>

            <v-btn
              color="primary"
              class="confirm-btn"
              depressed
              rounded
              :loading="loading"
              :disabled="!roleId"
              @click="save"
            >
              <v-icon left>mdi-check</v-icon>
              Salvar
            </v-btn>
          </div>
        </v-card>

        <div class="text-center mt-4 auth-footer">
          © {{ new Date().getFullYear() }} Salvia
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import http from "@/services/http";

export default {
  data: () => ({
    roleId: null,
    loading: false,
    error: "",
  }),

  async created() {
    const role = this.$store.getters["auth/roleId"];
    if (role) this.redirectByUserType();
  },

  methods: {
    async save() {
      this.loading = true;
      this.error = "";
      try {
        await http.post("/api/user/set-role", { role_id: this.roleId });
        await this.$store.dispatch("auth/refreshMe");
        this.redirectByUserType();
      } catch (e) {
        this.error =
          e.response?.data?.message ||
          "Não foi possível salvar. Tente novamente.";
      } finally {
        this.loading = false;
      }
    },

    redirectByUserType() {
      const userType = this.$store.getters["auth/userType"];

      if (userType === "assistant") {
        this.$router.replace({
          path: "/calendar-page",
          query: { mode: "clinic" },
        });
      } else if (userType === "doctor_solo" || userType === "doctor_clinic") {
        this.$router.replace({
          path: "/calendar-page",
          query: { mode: "doctor" },
        });
      } else {
        this.$router.replace({ name: "PatientsPage" });
      }
    },
  },
};
</script>

<style scoped>
.auth-bg {
  background: radial-gradient(
    1200px circle at 20% 10%,
    var(--ds-blue-100) 0%,
    var(--ds-surface-white) 45%,
    var(--ds-blue-bg) 100%
  );
}

.auth-card {
  border-radius: 18px;
  box-shadow: 0 12px 32px rgba(31, 77, 63, 0.08),
    0 2px 6px rgba(0, 0, 0, 0.04) !important;
}

.auth-section-header {
  display: flex;
  align-items: center;
  padding-bottom: 6px;
}

.auth-section-title {
  font-size: 11px;
  font-weight: 700;
  color: var(--ds-primary);
  text-transform: uppercase;
  letter-spacing: 0.8px;
}

.auth-title {
  font-size: 22px;
  font-weight: 700;
  color: var(--ds-text-strong);
  letter-spacing: -0.3px;
}

.auth-subtitle {
  font-size: 13px;
  color: var(--ds-text-soft);
  font-weight: 500;
}

.auth-hint {
  font-size: 12px;
  color: var(--ds-text-muted);
  font-weight: 500;
  line-height: 1.5;
}

.auth-alert {
  border-radius: 10px !important;
}

.auth-footer {
  font-size: 11px;
  color: var(--ds-text-muted);
  letter-spacing: 0.3px;
}

.role-header-avatar {
  background: var(--ds-blue-100) !important;
  box-shadow: 0 2px 6px rgba(31, 77, 63, 0.12);
}

.role-card {
  cursor: pointer;
  border-radius: 12px !important;
  border: 1.5px solid var(--ds-blue-100) !important;
  transition: transform 0.15s ease, box-shadow 0.15s ease,
    border-color 0.15s ease, background-color 0.15s ease;
}

.role-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(31, 77, 63, 0.12) !important;
  border-color: var(--ds-blue-200) !important;
}

.role-card.selected {
  border-width: 2px !important;
  border-color: var(--ds-primary) !important;
  background-color: var(--ds-blue-50) !important;
  box-shadow: 0 10px 24px rgba(31, 77, 63, 0.18) !important;
}

.role-card--success.selected {
  border-color: var(--ds-success-light) !important;
  background-color: #f1f8f4 !important;
  box-shadow: 0 10px 24px rgba(67, 160, 71, 0.18) !important;
}

.role-avatar {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
}

.role-avatar--doctor {
  background: var(--ds-blue-100) !important;
}

.role-avatar--assistant {
  background: var(--ds-green-surface) !important;
}

.role-title {
  font-size: 14px;
  font-weight: 700;
  color: var(--ds-text-strong);
  letter-spacing: -0.2px;
}

.role-description {
  font-size: 12px;
  color: var(--ds-text-soft);
  line-height: 1.5;
}

.confirm-btn {
  font-size: 13px !important;
  font-weight: 600 !important;
  letter-spacing: 0.2px !important;
  text-transform: none !important;
  height: 42px !important;
  padding: 0 24px !important;
  box-shadow: 0 4px 12px rgba(31, 77, 63, 0.25) !important;
}
</style>
